// extracted by mini-css-extract-plugin
module.exports = {"FranchiseBlock":"FranchiseBlock_FranchiseBlock__Y0sGd","ButtonLink":"FranchiseBlock_ButtonLink__tRuYN"};